import { useFeatureValue } from '@growthbook/growthbook-react';
import React from 'react';
import { useLocale } from './contexts/LocaleContext';
import { typedWindow } from './lib/Window';

export function ChatEmbed() {
  const { country } = useLocale();
  const decagonChatEnabled = useFeatureValue('decagon-chat-widget', false);

  // If experiment is enabled for session, use Decagon chat, otherwise use Ada chat
  if (decagonChatEnabled) {
    if (document.getElementById('chat-loader')) return <></>;
    const chatWidgetScript = document.createElement('script');
    chatWidgetScript.id = 'chat-loader';
    chatWidgetScript.src = 'https://decagon.ai/loaders/fi.js';
    chatWidgetScript.onload = () => {
      // Add user metadata containing the user's region for Decagon chat
      if (country && typedWindow.duet) {
        typedWindow.duet.setMetadata({
          userRegion: country,
        });
      }
    };
    document.body.appendChild(chatWidgetScript);
  } else {
    if (document.getElementById('__ada')) return <></>;
    const adaScript = document.createElement('script');
    adaScript.src = 'https://static.ada.support/embed2.js';
    adaScript.dataset.handle = 'fi';
    adaScript.id = '__ada';
    document.body.appendChild(adaScript);
  }

  return <></>;
}
